import { clearFormProgress, formProgressSync } from "../utils/formProgress";
import { handleSubmitBtnState, showSwalMessage } from "../utils/helpers";

const form = document.querySelector("form");
const formSyncId = "business_travel_form";

// CONVERT ALL SELECT ELEMENTS TO SELECT2 DROPDOWNS AND DISABLE SARCH
$("select").select2({
  minimumResultsForSearch: Infinity
});
// END

// FORM PROGRESS SYNC
formProgressSync(form, formSyncId);
// FORM PROGRESS SYNC  END

// SWEET ALERT
const onOpenCb = () => {
  clearFormProgress(form, formSyncId);
};
const swalAlertMsg = `<h5 class='text-base mobile:text-sm'>🎉🎉🎉 <br /> Congratulations on taking the first step towards your dream vacation! Your request has been successfully submitted.<br/> <b>We will reach out to you as soonest.</b></h5>`;
showSwalMessage(swalAlertMsg, onOpenCb);

//   ADD EVENT LISTENER TO FORM
form.addEventListener("submit", (e) => {
  const button = form.querySelector(".submit-btn");
  handleSubmitBtnState(button);
});
